import { TableRow } from '@repo/ui/table';
import { cn } from '@repo/utils/cn';
import React, { type ReactNode } from 'react';

type TableRowComponentProps = {
  className: string;
  children: ReactNode;
  isLiveMode?: boolean;
};

const TableRowComponent = ({ className, children, isLiveMode = false }: TableRowComponentProps) => {
  return !isLiveMode ? (
    <TableRow className={className}>{children}</TableRow>
  ) : (
    <div
      className={cn(
        'flex',
        // CSS animations for live table rows
        'duration-500 animate-in fade-in slide-in-from-top-5',
        // Optional: Add a subtle scale animation
        'scale-in-95 animate-in',
        className
      )}
    >
      {children}
    </div>
  );
};

export default TableRowComponent;
